"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// styles
require("./styles/group.scss");
var controllers_1 = require("./controllers");
var services_1 = require("./services");
var routes_1 = __importDefault(require("./config/routes"));
/**
 * @ngdoc module
 * @module rinca.apps.outlet
 * @name rinca.apps.outlet
 * @packageName rinca.apps
 * @description A module that includes the outlet component.
 */
angular.module('rinca.apps.group', ['ui.router'])
    .controller('GroupController', controllers_1.GroupController)
    .service('_group', services_1.GroupService)
    .config(routes_1.default);



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/group/index.ts
// module id = 476
// module chunks = 0